import React from "react";
import PropTypes from "prop-types";
import { Popup as SemanticPopup } from "semantic-ui-react";

import "./Popup.scss";

export const Popup = ({ bg = "gray-00", position, ...props }) => {
  return (
    <SemanticPopup
      className={`hireart-ds-popup ${bg}`}
      position={position}
      {...props}
    />
  );
};

Popup.propTypes = {
  bg: PropTypes.oneOf([
    "gray-00",
    "gray-10",
    "gray-60",
    "gray-70",
    "gray-80",
    "gray-90",
    "material-200",
    "material-300",
    "dark-600",
    "dark-700",
    "brand-400",
    "brand-500",
  ]),
  position: PropTypes.oneOf([
    "top left",
    "top center",
    "top right",
    "left center",
    "right center",
    "bottom left",
    "bottom center",
    "bottom right",
  ]),
};

